import { createAction, createSlice } from "@reduxjs/toolkit";
import {
  CashManagementProviderCustomerConfig,
  CashManagementProviderCustomerConfigCredentials,
} from "../models/CashManagementProviderCustomerConfig";
import { UUID } from "../utils";
import listFactory from "./listFactory";

export interface CMProviderCustomerConfigUUID {
  customerId?: UUID;
  providerId?: UUID;
  configId?: UUID;
}

const {
  slicePart,
  selectors,
} = listFactory<CashManagementProviderCustomerConfig>(
  "cashManagementProviderCustomerConfig"
);

const initialState = {
  ...slicePart.initialState,
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setItem: slicePart.reducers.setItem,
    setList: slicePart.reducers.setList,
  },
});

export const {
  setItem: setCashManagementProviderCustomerConfig,
  setList: setCashManagementProviderCustomerConfigs,
} = slice.actions;

export const createCashManagementProviderCustomerConfig = createAction<{
  customerId: UUID;
  providerId: UUID;
  data: CashManagementProviderCustomerConfigCredentials;
}>("createCashManagementProviderCustomerConfig");

export const fetchCashManagementProviderCustomerConfigs = createAction<{
  customerId: UUID;
}>("fetchCashManagementProviderCustomerConfigs");

export const fetchCashManagementProviderCustomerConfig = createAction<{
  configId: UUID;
}>("fetchCashManagementProviderCustomerConfig");

export const updateCashManagementProviderCustomerConfig = createAction<{
  configId: UUID;
  providerId: UUID;
  data: CashManagementProviderCustomerConfigCredentials;
}>("updateCashManagementProviderCustomerConfig");

export const selectCashManagementProviderCustomerConfigs = (
  customerId: UUID
) => (state: any) => {
  return state.cashManagementProviderCustomerConfig?.list?.filter(
    (config: CashManagementProviderCustomerConfig) =>
      config.customerId === customerId
  );
};

export const {
  selectItem: selectCashManagementProviderCustomerConfig,
} = selectors;

export const cashManagementProviderConfigOperationPaths = (
  ids: CMProviderCustomerConfigUUID
) => {
  const { customerId, configId } = ids;
  return {
    listing: [
      "cashManagement",
      "providerCustomerConfig",
      "listing",
      customerId,
    ],
    details: [
      "cashManagement",
      "providerCustomerConfig",
      "details",
      customerId,
    ],
    update: ["cashManagement", "providerCustomerConfig", "update", configId],
    create: [
      "cashManagement",
      "providerCustomerConfig",
      "providers",
      customerId,
    ],
  };
};

export default slice.reducer;
